module.exports = {"230883100":"抚远镇","230883101":"寒葱沟镇","230883102":"浓桥镇","230883103":"乌苏镇","230883200":"通江乡","230883201":"浓江乡","230883202":"海青乡","230883203":"别拉洪乡","230883204":"鸭南乡","230883500":"前哨农场","230883501":"前锋农场","230883502":"二道河农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230883.json
// module id = 710
// module chunks = 0